import { Injectable, inject } from '@angular/core';
import AngularRoutingHelperService from '../services/angular-routing-helper.service';
import Session from '../utils/session.service';
import DialogServices from '../services/dialog.service';
import { ModalProfileEditComponent } from '../components/modal-profile-edit/modal-profile-edit.component';

@Injectable({ providedIn: 'root' })
export default class ProfileServices {
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private session: Session = inject(Session);
	private dialogServices: DialogServices = inject(DialogServices);
	
	showProfileHeader() {
		var path: any = this.angularRoutingHelperService.getCurrentPath();
		var forbiddenPaths: Array<any> = ['chats', 'schedule', 'schedule/configure', 'settings', 'sp-settings'];
		var user: any = this.session.getSession().user;
		return forbiddenPaths.indexOf(path) === -1 && user
			&& (user.businessUserType === 'SERVICE_OWNER'
				|| (user.businessUserType === 'BUSINESS_CLIENT' && user.service && user.service.walletType != 'MOBILE_PACKAGE'));
	}
	
	openProfileModal(profile, ev, successCallback, errorCallback) {
		var dialog = this.dialogServices.show({
			controller: ModalProfileEditComponent,
			profile: profile,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
		dialog.afterClosed().subscribe(
			(profile) => {
				if (typeof successCallback === "function") successCallback(profile);
			},
			(error) => {
				if (typeof errorCallback === "function") errorCallback();
			}
		);
	}
	
}